import { Flow_0_0_2 } from '@flexus/core';

export const BUI_45: Flow_0_0_2 = {
	id: '45',
	name: 'job_cancelled',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'All Done'
		},
		viewRoles: {
			0: 'All Done'
		}
	},
	startNode: '',
	nodes: {}
};
